import { render } from "./LoginAccessRequest.vue?vue&type=template&id=67af031c"
import script from "./LoginAccessRequest.ts?vue&type=script&lang=js"
export * from "./LoginAccessRequest.ts?vue&type=script&lang=js"

import "./LoginAccessRequest.vue?vue&type=style&index=0&id=67af031c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__